import { useCalendarStore } from "../../store/useCalendarStore";
import { HoverContent } from "./AppointmentBlock/HoverContent";
import { Calendar, User } from "lucide-react";
import { Button, Tooltip } from "@heroui/react";
import { cn } from "@/utils";
import { useMediaQuery } from "@mantine/hooks";
import { i18n } from "@lingui/core";

const MonthAppointmentBlock = ({
  appointment,
  multiDay,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  appointment: any;
  multiDay?: {
    numDays: number;
    isLastBlock: boolean;
  };
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const { setSelectedAppointmentId, setHideModalTabs, users, resources } =
    useCalendarStore((state) => ({
      setSelectedAppointmentId: state.setSelectedAppointmentId,
      setHideModalTabs: state.setHideModalTabs,
      users: state.users,
      resources: state.resources,
    }));

  const { serviceColor, customers, isPreScheduled } = appointment;

  const isMultiDay = multiDay?.numDays && multiDay.numDays > 1;

  const startTime =
    multiDay && multiDay.isLastBlock
      ? new Date(appointment.startTimeUtc).toLocaleString(i18n.locale, {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : new Date(appointment.startTimeUtc).toLocaleTimeString(i18n.locale, {
          hour: "2-digit",
          minute: "2-digit",
        });

  return (
    <div
      className={cn("col-span-2 overflow-hidden", {
        "col-span-3": multiDay?.numDays === 2,
        "col-span-4": multiDay?.numDays === 3,
        "col-span-5": multiDay?.numDays === 4,
        "col-span-6": multiDay?.numDays === 5,
        "col-span-7": multiDay?.numDays === 6,
        "absolute top-7 left-0 z-50": isMultiDay,
      })}
      style={{
        width: `${(multiDay?.numDays ?? 1) * 100}%`,
      }}
    >
      <Tooltip
        classNames={{
          base: "pointer-events-none",
        }}
        closeDelay={0}
        content={
          <HoverContent
            appointment={appointment}
            viewCustomersPermission={appointment.permission}
            resources={resources}
            users={users}
          />
        }
        isDisabled={isMobile}
        showArrow
      >
        <Button
          size="sm"
          className={cn(
            "relative h-6 w-full justify-start rounded-sm bg-white px-px md:px-1 dark:bg-black",
            {
              "border-2 border-dashed": isPreScheduled,
              "border-solid":
                isPreScheduled &&
                appointment.customers.length >= appointment.numberOfPeople,
            },
          )}
          onPress={() => {
            setHideModalTabs(true);
            setSelectedAppointmentId(appointment.appointmentId);
          }}
        >
          <div className="z-20 w-full overflow-hidden text-left text-xs whitespace-nowrap">
            <div className="flex flex-col gap-1 text-sm">
              {!isPreScheduled &&
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                customers?.slice(0, 1).map((customer: any) => {
                  return (
                    <div
                      className="flex items-center justify-between gap-1"
                      key={`${appointment.appointmentId}-${customer.customerId}`}
                    >
                      <div className="flex items-center gap-0 text-black md:gap-1">
                        {customer.bookedFromForm ? (
                          <Calendar className="size-3 shrink-0" />
                        ) : (
                          <User className="size-3 shrink-0" />
                        )}
                        <p className="text-[0.7rem] text-black md:text-xs">
                          {customer?.name ?? ""} {customer?.lastName ?? ""}
                        </p>
                      </div>
                      {!multiDay || multiDay.isLastBlock ? (
                        <p className="text-xs text-black">{startTime}</p>
                      ) : undefined}
                    </div>
                  );
                })}
              {isPreScheduled ? (
                <div className="flex items-center gap-px">
                  <p className="text-xs font-medium">
                    {appointment.customers.length}/{appointment.numberOfPeople}
                  </p>
                  <p className="text-xs">{appointment.serviceName}</p>
                </div>
              ) : null}
            </div>
          </div>
          <div
            className="absolute inset-0 top-0 left-0 z-10 rounded-sm"
            style={{
              backgroundColor: `${serviceColor}70`,
            }}
          ></div>
        </Button>
      </Tooltip>
    </div>
  );
};

export default MonthAppointmentBlock;
